<div class="termos-list">

  <app-page-header
    title="Termos de Ciência"
    subtitle="Mantenha os termos de ciência e as funcionalidades que os utilizam."
  >
    <ng-container actions>
      <button
        type="button"
        class="btn-primary btn-toolbar"
        data-testid="btn-novo-termo"
        [disabled]="criandoTermo()"
        (click)="abrirCriacao()"
      >
        Novo Termo
      </button>
    </ng-container>
  </app-page-header>

  <div class="termos-list__layout">
    <!-- Coluna 1: consulta e seleção do termo -->
    <section class="termos-list__panel" aria-labelledby="termos-list-section-title">
      <h2 id="termos-list-section-title" class="termos-list__panel-title">Termos Cadastrados</h2>

      <div class="termos-list__filtros">
        <label class="termos-list__sr-only" for="termos-list-busca">Buscar termo</label>
        <input
          id="termos-list-busca"
          type="search"
          class="termos-list__control"
          placeholder="Buscar termo"
          autocomplete="off"
          [value]="busca()"
          (input)="onBuscaChange($any($event.target).value)"
          (keyup.enter)="buscar()"
          data-testid="termos-list-busca"
        />

        <label class="termos-list__sr-only" for="termos-list-status">Status</label>
        <select
          id="termos-list-status"
          class="termos-list__control"
          [value]="status()"
          (change)="onStatusChange($any($event.target).value)"
          data-testid="termos-list-status"
        >
          @for (option of statusOptions; track option.value) {
            <option [value]="option.value">{{ option.label }}</option>
          }
        </select>

        <div class="termos-list__filtros-acoes">
          <button
            type="button"
            class="btn-outline-primary btn-toolbar"
            data-testid="termos-list-limpar"
            (click)="limpar()"
          >
            Limpar
          </button>
          <button
            type="button"
            class="btn-primary btn-toolbar"
            data-testid="termos-list-buscar"
            (click)="buscar()"
          >
            Buscar
          </button>
        </div>
      </div>

      @if (termos().length === 0) {
        <app-empty-state message="Nenhum termo encontrado" />
      } @else {
        <ul class="termos-list__itens" role="list">
          @for (termo of termos(); track termo.id) {
            <li>
              <!-- Durante a criação a lista fica fora de alcance: trocar de termo ali
                   descartaria, sem aviso, o formulário que está sendo preenchido. -->
              <button
                type="button"
                class="termos-list__item"
                [class.termos-list__item--ativo]="isSelecionado(termo.id)"
                [attr.aria-current]="isSelecionado(termo.id) ? 'true' : null"
                data-testid="termos-list-item"
                [disabled]="criandoTermo()"
                (click)="selecionarTermo(termo.id)"
              >
                <span class="termos-list__item-topo">
                  <span class="termos-list__item-nome">{{ termo.nome }}</span>
                  <app-status-badge [status]="termo.status" />
                </span>
                <span class="termos-list__item-meta">
                  Versão {{ termo.versao }} - {{ formatDate(termo.dataVersao) }}
                </span>
              </button>
            </li>
          }
        </ul>

        <app-pagination
          [currentPage]="currentPage()"
          [pageSize]="pageSize"
          [totalItems]="totalItens()"
          (pageChange)="onPageChange($event)"
        />
      }
    </section>

    <!-- Colunas 2 e 3: detalhe e vínculos do termo aberto, ou o formulário do termo novo -->
    @if (termoPainel(); as termo) {
      <app-termo-detalhe-panel
        [termo]="termo"
        [modoCriacao]="criandoTermo()"
        [(arquivoNovo)]="arquivoPendente"
        (salvar)="onSalvarTermo($event)"
        (criar)="onCriarTermo($event)"
        (cancelarCriacao)="descartarRascunho()"
        (removerArquivo)="onRemoverArquivo()"
        (arquivoRecusado)="onArquivoRecusado($event)"
        (visualizarArquivo)="onVisualizarArquivo($event)"
      />

      @if (criandoTermo()) {
        <!-- Vincular depende de um termo gravado; a coluna fica, explicando a espera. -->
        <section class="termos-list__panel" aria-labelledby="termos-list-vinculos-espera-title">
          <h2 id="termos-list-vinculos-espera-title" class="termos-list__panel-title">
            Vincular a Funcionalidades
          </h2>
          <p class="termos-list__espera" data-testid="termos-list-vinculos-espera">
            Disponível depois que o termo for criado.
          </p>
        </section>
      } @else {
        <app-termo-vinculos-panel
          [funcionalidades]="termo.funcionalidades"
          (salvar)="onSalvarVinculos($event)"
        />
      }
    }
  </div>

  <aside class="termos-list__importante" aria-labelledby="termos-list-importante-title">
    <div>
      <h2 id="termos-list-importante-title" class="termos-list__importante-title">Importante</h2>
      <p class="termos-list__importante-texto">
        Ao vincular um termo a uma funcionalidade, os novos participantes visualizarão o termo
        selecionado no momento da adesão.
      </p>
      <p class="termos-list__importante-texto">
        Alterações no termo não impactam adesões já concluídas.
      </p>
    </div>
  </aside>

  @if (showCriarDialog()) {
    <app-alert-dialog
      title="Criar Termo"
      message="Confirma a criação deste termo de ciência?"
      description="O termo entra na lista com o PDF informado; a versão e a data são definidas automaticamente. Depois de criado, você pode vinculá-lo às funcionalidades do portal."
      cancelLabel="Revisar"
      confirmLabel="Criar Termo"
      [showConfirmIcon]="false"
      (cancel)="cancelarCriacaoTermo()"
      (confirm)="confirmarCriacaoTermo()"
    />
  }

  @if (showSalvarDialog()) {
    <app-alert-dialog
      [title]="dialogoSalvar().title"
      [message]="dialogoSalvar().message"
      [description]="dialogoSalvar().description"
      cancelLabel="Cancelar"
      [confirmLabel]="dialogoSalvar().confirmLabel"
      [showConfirmIcon]="false"
      (cancel)="cancelarSalvarTermo()"
      (confirm)="confirmarSalvarTermo()"
    />
  }

  @if (showRemoverArquivoDialog()) {
    <app-alert-dialog
      title="Remover PDF"
      message="Confirma a remoção do arquivo deste termo?"
      description="O arquivo escolhido é descartado. Você pode anexar outro antes de criar o termo."
      cancelLabel="Cancelar"
      confirmLabel="Remover PDF"
      [showConfirmIcon]="false"
      (cancel)="cancelarRemoverArquivo()"
      (confirm)="confirmarRemoverArquivo()"
    />
  }

  @if (showVinculosDialog()) {
    <app-alert-dialog
      title="Salvar Vínculos"
      message="Tem certeza que deseja salvar os vínculos deste termo?"
      description="Essa ação impacta as funcionalidades vinculadas a este termo: os novos participantes passarão a vê-lo nas funcionalidades selecionadas, e ele deixará de ser exibido nas que forem desmarcadas. Adesões já concluídas não são afetadas."
      cancelLabel="Cancelar"
      confirmLabel="Salvar Vínculos"
      [showConfirmIcon]="false"
      (cancel)="cancelarSalvarVinculos()"
      (confirm)="confirmarSalvarVinculos()"
    />
  }

  @if (arquivoVisualizado(); as arquivo) {
    <app-pdf-viewer-dialog
      [nome]="arquivo.nome"
      [url]="arquivo.url"
      (fechar)="fecharVisualizacaoArquivo()"
    />
  }
</div>
